<template>
    <div class="">
        
        <template>
            <the-header />
        </template>

        <div class="site-wrapper-reveal">
            <div class="about-banner-wrap banner-space about-us-bg position-relative">
                <div class="banner-overlay"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 ml-auto mr-auto">
                            <div class="about-banner-content text-center">
                                <h1 class="mb-15 text-white">Axis Realty Homes For Rent</h1>
                                <h5 class="font-weight--normal text-white">Proven 15 years’ track record in property management. </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="feature-large-images-wrapper section-space--pt_60">
                <div class="container">
                    <div class="cybersecurity-about-box">
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="conact-us-wrap-one managed-it">
                                    <h5 class="heading ">Find the Perfect Home </h5>
                                </div>
                            </div>
                            <div class="col-lg-7 offset-lg-1">
                                <div class="button-group-wrap text-right">
                                    <router-link :to="`${baseUrl}/apply-for-rental`" class="ht-btn ht-btn-md mr-md-3 mb-5 inline-block text-white">Apply For Rental</router-link>
                                    <router-link :to="`${baseUrl}/contact-us`" class="ht-btn ht-btn-md ht-btn--solid inline-block">Inquire Now</router-link>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="cybersecurity-about-text">
                                    <div class="text"><span v-html="property.description"></span></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="blog-pages-wrapper section-space--ptb_30">
                <div class="container">
                    <div class="row">

                        <div class="col-lg-5 order-lg-1 order-1">
                            <div class="page-sidebar-content-wrapper page-sidebar-left  small-mt__40 tablet-mt__40">
                                <div class="mb-6">
                                    <h3 class="post-title">{{property.address}}</h3>
                                </div>
                                <div class="portfolio-details-table section-space--mt_20">
                                    <table class="">
                                        <tbody>
                                            <tr class="portfolio-details-tags">
                                                <td class="label">Type</td>
                                                <td class="text-left">{{property.portion_type}}</td>
                                                <td class="label">Rent</td>
                                                <td class="text-left">{{property.monthly_rent| currency('$ ', 2, { thousandsSeparator: ',' })}}</td>
                                            </tr>
                                            <tr class="portfolio-details-tags">
                                                <td class="label">Beds</td>
                                                <td class="text-left">{{property.property_type}}</td>
                                                <td class="label">Baths</td>
                                                <td class="text-left">{{property.bath_rooms}}</td>
                                            </tr>
                                            <tr class="portfolio-details-tags">
                                                <td class="label">Deposit</td>
                                                <td class="text-left">{{property.security_deposit| currency('$ ', 2, { thousandsSeparator: ',' })}}</td>
                                                <td class="label"></td>
                                                <td class="text-left"></td>
                                            </tr>
                                        </tbody>
                                    </table>                                     
                                </div>

                                <div class="sidebar-widget widget-blog-recent-post wow move-up">

                                    <h4 class="sidebar-widget-title">Eligibility</h4>

                                    <ul>
                                        <li v-for="(eligibility, index) in property.eligibilities" :key="index">
                                            <a class="font-weight--reguler">{{eligibility.eligibility_criteria}}</a>
                                        </li>
                                    </ul>

                                </div>

                                <div class="post-info lg-blog-post-info  wow move-up">

                                    <div class="post-meta mt-5">
                                        <div class="post-date mb-4">
                                            <feather-icon icon="PhoneIcon" svgClasses="h-5 w-5" class="mr-4" />
                                            314 474 5277
                                        </div>
                                        <div class="post-view">
                                            <feather-icon icon="HomeIcon" svgClasses="h-5 w-5" class="mr-4" />
                                            {{property.address}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-7 order-lg-2 order-2">
                            <div class="main-blog-wrap">
                                <div class="single-blog-item">
                                    <div class="post-feature blog-thumbnail wow move-up">
                                        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl + ' gallery'">
                                            <swiper-slide v-for="(image, index) in property.images" :key="index">
                                                <img class="responsive" :src="image" alt="Property Images">
                                            </swiper-slide>
                                            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                                            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                                        </swiper>
                                    </div>

                                    <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs" :dir="$vs.rtl ? 'rtl gallery' : 'ltr gallery'" :key="$vs.rtl + ' thumbs'">
                                        <swiper-slide v-for="(image, index) in property.images" :key="index">
                                            <img class="responsive" :src="image" alt="Property Thumb Images">
                                        </swiper-slide>
                                    </swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="blog-pages-wrapper section-space--pb_30">
                <div class="container">                    
                    <div class="row">
                        <div class="col-lg-12 ht-tab-wrap mt-40">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="google-map">
                                        <iframe :src="'https://maps.google.com/maps?q='+property.lat +',' +property.lang +'&hl=es;z=14&amp;output=embed'" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
            
        <the-footer />
    </div>
</template>

   
<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import TheHeader   from '@/layouts/components/TheHeader.vue'
import TheFooter   from '@/layouts/components/TheFooter.vue'
import Contact from '@/js/password.js'
import UserProperty from '@/js/userProperty.js'

export default {
  components: {
    swiper,
    swiperSlide,
    TheHeader,
    TheFooter
  },
  data () {
    return {
      property: {},
      sendMessage: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      swiperOptionTop: {
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper
      const swiperThumbs = this.$refs.swiperThumbs.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  methods: {
    setFullVacantPropertyId (property) {
      this.property = property
      console.log('property', property)
    },
    submitForm () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          Contact.addContact(this, this.sendMessage)
        } else {
          console.log('errors', this.errors)
        }
        // this.sendMessage = ''
      })
    },
    contactAdded (data) {
      this.$vs.loading.close()
      this.$vs.dialog({
        type: 'alert',
        color: 'success',
        title: 'Contact',
        text: data.return_message,
        accept: null
      })
    },
    contactNotAdded (message) {
      this.$vs.loading.close()
      this.$vs.dialog({
        type: 'alert',
        color: 'danger',
        title: 'Contact',
        text: message,
        accept: null
      })
    }
  },
  created () {
    UserProperty.getFullVacantPropertyById(this, this.$route.params.id)
  },
  computed: {
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, ('/'))
    }
  }

}
</script>

<style lang="scss" scoped>
  .swiper-container {
    background-color: #f5f5f5;
  }
  .gallery-top {
    height: 80%!important;
    width: 100%;
  }
  .gallery-top .swiper-wrapper .swiper-slide img.responsive {
    height: 400px;
  }
  .gallery-thumbs {
    height: 20%!important;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }
  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }
  .gallery-thumbs .swiper-slide img.responsive {
    height: 100px;
  }
</style>